import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "person-picker-body"
};
const _hoisted_2 = {
  class: "person-search"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "person-row-main"
};
const _hoisted_5 = {
  class: "person-avatar"
};
const _hoisted_6 = {
  class: "person-avatar-char"
};
const _hoisted_7 = {
  class: "person-meta"
};
const _hoisted_8 = {
  class: "person-name"
};
const _hoisted_9 = {
  key: 0,
  class: "person-phone"
};
const _hoisted_10 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
};
const _hoisted_11 = {
  class: "person-picker-footer"
};
const _hoisted_12 = {
  class: "person-footer-info"
};
const _hoisted_13 = {
  class: "person-footer-actions"
};
import { ref, reactive, computed } from 'vue';
import { Search } from '@element-plus/icons-vue';
import { getExternalPersonOptions } from '@/api/taxPlanning';
export default {
  __name: 'ExternalPersonPicker',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    const dialogVisible = ref(false);
    const loading = ref(false);
    const personList = ref([]);
    const selectedPerson = ref(null);
    const queryForm = reactive({
      keyword: ''
    });

    // 下拉数据源为启用人员全量列表，关键字在前端按姓名/手机号过滤
    const filteredList = computed(() => {
      const keyword = queryForm.keyword.trim().toLowerCase();
      if (!keyword) return personList.value;
      return personList.value.filter(person => (person.name || '').toLowerCase().includes(keyword) || (person.phone || '').toLowerCase().includes(keyword));
    });
    const isSelected = person => {
      return selectedPerson.value && String(selectedPerson.value.id) === String(person.id);
    };
    const onPersonClick = person => {
      selectedPerson.value = isSelected(person) ? null : person;
    };
    const open = () => {
      dialogVisible.value = true;
    };
    const onOpen = async () => {
      queryForm.keyword = '';
      selectedPerson.value = null;
      loading.value = true;
      try {
        personList.value = (await getExternalPersonOptions()) || [];
        if ($props.modelValue) {
          selectedPerson.value = personList.value.find(p => String(p.id) === String($props.modelValue)) || null;
        }
      } catch (error) {
        console.error('获取外部人员列表失败', error);
      } finally {
        loading.value = false;
      }
    };
    const handleConfirm = () => {
      $emits('confirm', selectedPerson.value ? [{
        id: selectedPerson.value.id,
        name: selectedPerson.value.name
      }] : []);
      dialogVisible.value = false;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onOpen: onOpen,
        "modal-class": "person-picker-overlay",
        title: "选择外部人员",
        width: "460px",
        class: "person-picker-dialog",
        "append-to-body": "",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, [selectedPerson.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode("已选 " + _toDisplayString(selectedPerson.value.name), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode("未选择")], 64))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleConfirm
        }, "确认")])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: queryForm.keyword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryForm.keyword = $event),
          class: "person-search-input",
          placeholder: "搜索姓名或手机号",
          clearable: ""
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Search))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          tag: "div",
          class: "person-list"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, person => {
            return _openBlock(), _createElementBlock("div", {
              key: person.id,
              class: _normalizeClass(["person-row", {
                'is-active': isSelected(person)
              }]),
              onClick: $event => onPersonClick(person)
            }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString((person.name || '?').charAt(0)), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(person.name), 1), person.phone ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(person.phone), 1)) : _createCommentVNode("", true)])]), _createElementVNode("span", {
              class: _normalizeClass(["person-check", {
                'is-checked': isSelected(person)
              }])
            }, [isSelected(person) ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "3",
              d: "M5 13l4 4L19 7"
            }, null, -1)]))])) : _createCommentVNode("", true)], 2)], 10, _hoisted_3);
          }), 128)), !loading.value && personList.value.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "暂无启用的外部人员",
            "image-size": 64
          })) : !loading.value && personList.value.length > 0 && filteredList.value.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "当前列表无匹配人员",
            "image-size": 64
          })) : _createCommentVNode("", true)]),
          _: 1
        })), [[_directive_loading, loading.value && personList.value.length === 0]])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};